







































import Enumerable from "linq";
import { Mixins, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { EditorItemMixin } from "./mixins";
import { ModelEditableMixin } from "../../../system/mixins";
import { StandardOption, DateSelectableMixin } from "../../../system/selectors/mixins";
import { Reception } from "../../../../domain/workflow/reception";
import { ReceptionInputSection } from "../../../../domain/workflow/items";

import OptionDropDownSelector from "../../../system/selectors/OptionDropDownSelector.vue";
import DatePicker from "../../../system/selectors/DatePicker.vue";
import { ReceptionDateTranslator } from "../../../../domain/workflow";
import { InOutKinds } from "../../../../domain/workflow/kinds";

@Component({
  components: {
    DatePicker,
    OptionDropDownSelector,
  }
})
export default class ReceptionInformationEditor extends Mixins(EditorItemMixin, ModelEditableMixin, DateSelectableMixin) {
  // ModelEditableMixinに実体あり
  editingSource: Reception;
  _dateTranslator: ReceptionDateTranslator;

  @Prop()
  inputSectionItems: ReceptionInputSection[];

  @Prop()
  isInOutTypeEnable: boolean;

  data(): any {
    return {
      // 初期化
      inputSectionOptions: !this.inputSectionItems ? [] : this.toInputSectionOption(this.inputSectionItems),
      inOutTypeOptions: [
        new StandardOption<InOutKinds>("", InOutKinds.None),
        new StandardOption<InOutKinds>("入院", InOutKinds.In),
        new StandardOption<InOutKinds>("外来", InOutKinds.Out),
      ],
    };
  }
  inputSectionOptions: StandardOption<ReceptionInputSection>[];
  inOutTypeOptions: StandardOption<InOutKinds>[];

  created(): void {
    this._dateTranslator = new ReceptionDateTranslator();
  }

  mounted(): void {
    // 入力部署の選択肢設定を変更した場合、登録済みの入力部署が選択肢に無いこともあるのでここでコンボ用の選択肢を再作成する
    this.inputSectionOptions = this.toInputSectionOption(this.inputSectionItems);
  }

  // 入力部署コンボ用選択肢作成
  toInputSectionOption(items: ReceptionInputSection[]): StandardOption<ReceptionInputSection>[] {
    // isDisable=false もしくは編集時に選択されている入力部署を表示
    const options = Enumerable.from(this.inputSectionItems)
      .where(item => !item.isDisable || (this.inputSection && item.id === this.inputSection.id))
      .select(item => new StandardOption<ReceptionInputSection>(item.name, item))
      .toArray();
    
    options.unshift(new StandardOption<ReceptionInputSection>("", null));

    return options;
  }

  inputSectionAreEqual(source: ReceptionInputSection, dest: ReceptionInputSection): boolean {
    return ReceptionInputSection.areEqual(source, dest);
  }

  @Watch("inputSectionItems") // propの更新を監視
  onInputSectionItemsUpdated(newValue: ReceptionInputSection[], oldValue: ReceptionInputSection[]) {
    console.log("watch");
    if (!newValue) {
      return;
    }
    this.inputSectionOptions = this.toInputSectionOption(newValue);
  }

  @Emit()
  selectedLinkedReceptionDate(diffDays: number): void {}

  get receptionDate(): Date {
    if (!this.editingSource.receptionDate) {
      return this.today();
    } // 本日
    return this.editingSource.receptionDate;
  }

  set receptionDate(value: Date) {
    this.writeProperty((r: Reception) => (r.receptionDate = value ? value : this.today()));
  }

  get receptionNumber(): string {
    return this.editingSource.receptionNumber;
  }

  set receptionNumber(value: string) {
    this.writeProperty((c: Reception) => (c.receptionNumber = value));
  }

  get inputSection(): ReceptionInputSection {
    if (!this.editingSource.inputSection) {
      return null;
    }
    if (
      this.editingSource.inputSection.id === null ||
      this.editingSource.inputSection.id === undefined
    ) {
      return null;
    }

    return this.editingSource.inputSection;
  }

  set inputSection(value: ReceptionInputSection) {
    this.writeProperty((c: Reception) => (c.inputSection = value));
  }

  get inOutType(): InOutKinds {
    return (!this.editingSource.inOutType)
      ? InOutKinds.None
      : this.editingSource.inOutType;
  }

  set inOutType(value: InOutKinds) {
    this.writeProperty((c: Reception) => (c.inOutType = value));
  }

  async selectLinkedDate(): Promise<void> {
    const result = await this.$commonDialogs.date.dateSelector.show(this.receptionDate);
    if (result === undefined) { return; } // 日付選択を中止する場合
    const currentSelectedDate = result ? result : this.today();
    // 日付を未選択にする場合は日数差をnullとしない為に、今日の日付として扱う

    this.receptionDate = currentSelectedDate;
    const diffDays = this._dateTranslator.durationDays(this.receptionDate, currentSelectedDate);
    if (!diffDays) { return; }
    this.selectedLinkedReceptionDate(diffDays);
  }

  get shouldShowInputSectionAlert(): boolean {
    // 編集の時は有効な入力部署かどうかはチェックしないので新規登録の時だけ警告を表示する
    // idは未登録の場合はnullではなく0が入っている
    return !!this.inputSection && this.inputSection.isDisable && !this.editingSource.id;
  }

  get inputSectionAlertStyles(): any {
    return {
      color: this.$configuration.style.alertIndication.color,
      backgroundColor: this.$configuration.style.alertIndication.backgroundColor,
    };
  }
}
